import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function Checkout() {
  const { courseId } = useParams();
  const { user } = useAuth();
  const [code, setCode] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setMsg("");
    if (!user) return nav("/login?next=/redeem");
    setLoading(true);
    try {
      const { data } = await api.post("/redeem", { code });
      setMsg(`Curso "${data.course.title}" activado con éxito`);
      setTimeout(() => nav(`/learn/${data.course.id}`), 1200);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-16">
      <div className="text-center mb-8">
        <div className="w-14 h-14 rounded-full bg-naranja/10 text-naranja flex items-center justify-center mx-auto mb-4">
          <KeyRound className="w-7 h-7" strokeWidth={1.75} />
        </div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl text-marino tracking-tight">Activar curso</h1>
        <p className="mt-3 text-marino/70">Ingresa el código de activación entregado por tu empresa o distribuidor.</p>
      </div>

      <form onSubmit={submit} className="bg-white border border-gris/30 rounded-xl p-6 sm:p-8 shadow-sm space-y-5">
        <div>
          <label className="block text-sm font-medium text-marino mb-2">Código de activación</label>
          <input
            data-testid="activation-code-input"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            placeholder="OMPEC-XXXX-XXX"
            className="w-full uppercase tracking-widest font-mono text-center text-lg px-4 py-3 border-2 border-gris/50 rounded-lg focus:border-marino focus:outline-none"
          />
          <p className="mt-2 text-xs text-marino/60">Formato: OMPEC-XXXX-XXX (letras y números)</p>
        </div>

        {err && <div data-testid="checkout-error" className="text-naranja text-sm bg-naranja/10 border border-naranja/30 rounded-lg p-3">{err}</div>}
        {msg && (
          <div data-testid="checkout-success" className="text-green-700 bg-green-50 border border-green-200 rounded-lg p-3 flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5" /> {msg}
          </div>
        )}

        <button
          disabled={loading}
          data-testid="redeem-submit"
          className="w-full bg-naranja text-white py-3 rounded-lg font-semibold hover:bg-naranjaHover transition-colors disabled:opacity-60"
        >
          {loading ? "Validando..." : "Activar curso"}
        </button>

        {!user && (
          <p className="text-sm text-marino/70 text-center">
            ¿No tienes cuenta? <Link to="/register" className="text-naranja font-medium">Regístrate</Link> o <Link to="/login" className="text-naranja font-medium">inicia sesión</Link>.
          </p>
        )}
      </form>

      {courseId && (
        <div className="mt-6 text-center">
          <Link to={`/courses/${courseId}`} className="text-marino/70 text-sm hover:text-marino">← Volver al detalle del curso</Link>
        </div>
      )}
    </div>
  );
}
